import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=fdbfb2a2"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports